import { createSlice } from "@reduxjs/toolkit";
import { InitialLeafWareHouseFormData } from "../../ConstantData/InitialData";

const leafWareHouseSlice = createSlice({
  name: "leafwarehouse",
  initialState: {
    leafWareHouseList: [],
    isError: false,
    errorData: {},
    initialData: InitialLeafWareHouseFormData,
  },
  reducers: {
    getAllLeafWareHouse: (state, action) => {
      state.leafWareHouseList = action.payload;
    },
    getLeafWareHouse: () => {},
    createLeafWareHouse: (state, action) => {
      state.leafWareHouseList.push({ ...action.payload });
    },
    getLeafWareHouseDataEdit: (state, action) => {
      state.dataEdit = action.payload;
    },
    setErrorData: (state, action) => {
      state.errorData = action.payload.message;
      state.isError = action.payload.isError;
    },
    setInitialData: (state, action) => {
      state.initialData = { ...InitialLeafWareHouseFormData };
    },
    updateLeafWareHouse: (state, action) => {},
    deleteLeafWareHouse: () => {},
  },
});

export const leafWareHouseSliceAction = leafWareHouseSlice.actions;
export default leafWareHouseSlice.reducer;
